module.exports = __webpack_public_path__ + "static/media/pro_3.93bea67e.jpg";